import TemplateSurveyState from 'containers/SurveyPage/TemplateSurveyState';
import { transformPropsDeep, escapeHTML } from 'containers/App/utils';
import { find, get } from 'lodash';
import {
  getAttributeIds,
  getAttributeValueIds,
} from 'containers/QuestionnairePage/QuestionGroup/utils';
import {
  mapQuestionsAndGroupsAsNodes,
  duplicateQuestion as duplicateQuestionHelper,
} from 'containers/QuestionnairePage/utils';
import { SURVEY_TYPE_PEEQ } from 'containers/Survey/constants';

const vanWestendorpGenerator = ({ template, variables, surveyType }) => {
  const Survey = new TemplateSurveyState({
    fetchedTargeting:
      surveyType === SURVEY_TYPE_PEEQ
        ? template.peeqTargetingTemplate
        : template.regularTargetingTemplate,
  });

  // extract and prepare user variables
  const yourProductName = get(
    find(variables, ['name', 'product_name']),
    'value',
    '',
  );
  const yourProductDescription = get(
    find(variables, ['name', 'product_description']),
    'value',
    {},
  );

  const yourProductDecimals = get(
    find(variables, ['name', 'decimals']),
    'value',
    '',
  );
  const yourProductCurrency = get(
    find(variables, ['name', 'currency']),
    'value',
    '',
  );
  const yourPriceMin = get(find(variables, ['name', 'price_min']), 'value', '');
  const yourPriceMax = get(find(variables, ['name', 'price_max']), 'value', '');
  const yourNmsExtension = get(
    find(variables, ['name', 'include_likelihood']),
    'value',
    false,
  );

  const replaceProductNameText = (value) =>
    value.replace(/\{\{product_name\}\}/gi, escapeHTML(yourProductName));
  const replaceProductCurrencyText = (value) =>
    value.replace(/\{\{currency\}\}/gi, escapeHTML(yourProductCurrency));

  const replaceStrings = (value) => {
    let newValue = replaceProductCurrencyText(value);
    newValue = replaceProductNameText(newValue);
    return newValue;
  };

  const questionnaireTemplate = transformPropsDeep(
    template.questionnaireTemplate,
    { prompt: replaceStrings, htmlPrompt: replaceStrings },
  );

  const { nodes: vanWestendorpTemplateQuestions } =
    mapQuestionsAndGroupsAsNodes(questionnaireTemplate);

  const descriptionQuestion = duplicateQuestionHelper(
    vanWestendorpTemplateQuestions[0],
  );
  const vanWestendorpGroupQuestion = duplicateQuestionHelper(
    vanWestendorpTemplateQuestions[1],
  );

  Survey.questionnaire.addQuestion(descriptionQuestion);
  Survey.questionnaire.addQuestion(vanWestendorpGroupQuestion);

  const attributeId = getAttributeIds(vanWestendorpGroupQuestion)[0];
  const attributeValueId = getAttributeValueIds(
    vanWestendorpGroupQuestion,
    attributeId,
  )[0];

  Survey.questionnaire.updateGroupAttributeValue({
    refId: vanWestendorpGroupQuestion.refId,
    attributeRefId: attributeId,
    attributeValueRefId: attributeValueId,
    text: `<div>${yourProductDescription.text}</div>`,
    media: yourProductDescription.media,
  });

  if (!yourNmsExtension) {
    Survey.questionnaire.updateVanWestendorpLikelihood(
      vanWestendorpGroupQuestion.refId,
      yourNmsExtension,
    );
  }

  const settings = {
    min: parseFloat(yourPriceMin),
    max: parseFloat(yourPriceMax),
    decimalCount: parseInt(yourProductDecimals, 10),
  };

  Survey.questionnaire.updateVanWestendorpSettings({
    refId: vanWestendorpGroupQuestion.refId,
    settings,
  });

  return { state: Survey.state };
};

export default vanWestendorpGenerator;
